import React, { useState } from "react"
import TextField from '@mui/material/TextField';
import { t } from 'i18next';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import InputAdornment from '@mui/material/InputAdornment';
import { FormControl, IconButton, InputLabel, OutlinedInput } from "@mui/material";
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { Validate } from "../../functionsIsmesti/validation";
import FormHelperText from '@mui/material/FormHelperText';


const PrimaryTextField = ({
    type: defaultType, classNameForm, label, errorMsg, onChange, validate, size, required, id, name, ...rest
}) => {

    const [passwordShown, setPasswordShown] = useState(false);
    const [type, setType] = useState(defaultType);
    const [error, setError] = useState(false)
    const [error2, setError2] = useState(false)
    const togglePasswordVisiblity = () => {
        setPasswordShown(passwordShown ? false : true);
    };

    // Generate consistent ID for both label and input
    const fieldId = id || `field-${label}`;
    const fieldName = name || `field-${label}`;

    return (
            <div className="txtFieldContainer">
                <FormControl variant="outlined" className={classNameForm} >
                    <InputLabel
                        className={error ? 'errorLabel txtfieldLabelInput' : 'txtfieldLabelInput'}
                        htmlFor={fieldId}>{t(label)}</InputLabel>
                    <OutlinedInput
                        required={required}
                        size={size}
                        className="txtField"
                        id={fieldId}
                        name={fieldName}
                        label={t(label)}
                        onChange={(e) => {
                            onChange(e.currentTarget.value);
                        }}
                        onBlur={(e) => {
                            if (Validate(e.currentTarget.value, validate) || e.currentTarget.value == '') { setError(false); setError2(false) } else {
                                setError(true)
                                setError2(false)
                            }
                            // if (error == true) { setError2(true) } else { setError2(false) }
                        }}
                        type={type == 'password' && !passwordShown ? 'password' : 'text'}
                        endAdornment={
                            type == 'password' ?
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label="toggle password visibility"
                                        onClick={togglePasswordVisiblity}
                                        onMouseDown={togglePasswordVisiblity}
                                        edge="end"
                                    >
                                        {passwordShown ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                                : ''
                        }
                        {...rest}

                    />
                    {error ?
                        <FormHelperText>
                            {errorMsg}
                        </FormHelperText>
                        : ''
                    }
                </FormControl>
            </div>
    )
}
export default PrimaryTextField
